import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

interface MarketAppControlsContextType {
  showShareBlock: boolean;
  editMode: boolean;
  showAddToDashboard: boolean;
}

const MarketAppControlsContext = createContext<MarketAppControlsContextType | undefined>(undefined);

interface MarketAppControlsProviderProps {
  children: ReactNode;
  showShareBlock?: boolean;
  editMode?: boolean;
  showAddToDashboard?: boolean;
}

export const MarketAppControlsProvider = ({
  children,
  editMode = false,
  showShareBlock = true,
  showAddToDashboard = true
}: MarketAppControlsProviderProps) => {
  const value = useMemo(
    () => ({
      showShareBlock,
      editMode,
      showAddToDashboard
    }),
    [showShareBlock, editMode, showAddToDashboard]
  );

  return <MarketAppControlsContext value={value}>{children}</MarketAppControlsContext>;
};

export const useMarketAppControls = (): MarketAppControlsContextType => {
  const context = useContext(MarketAppControlsContext);
  if (context === undefined) {
    throw new Error('useMarketAppControls must be used within a MarketAppControlsProvider');
  }
  return context;
};
